<template>
	<section id="minha-conta">
		<h2>minha conta</h2>
	</section>
</template>

<script>
export default {
	name: 'MinhaConta'
}
</script>

<style lang="scss" scoped>
#minha-conta {
	h2 {
		color: seagreen;
	}
}
</style>
